import type { GenieKnowledgeEntry } from '../../types';

export const myotonicDystrophy: GenieKnowledgeEntry = {
  id: 'myotonic_dystrophy',
  name: 'Distrofia Miotónica',
  category: 'miopatico',
  conversation: {
    headline:
      'Miopatía hereditaria con miotonía (relajación muscular retardada). Descargas miotónicas en EMG.',
    edxHighlights: [
      'Descargas miotónicas: trenes de positividad con frecuencia/modulación variable',
      'PAUMs miopáticos con duración y amplitud reducidas',
      'Patrón distal > proximal (diferente de miopatías inflamatorias)',
      'NCS: CMAPs reducidos en músculos distales',
    ],
    pearls: [
      'Miembros congénitos: hipotonía severa, facies, retraso del desarrollo.',
      'Tipo 1 (Steinert): CTG repeat en DMPK; tipo 2: CNBP.',
    ],
    nextSteps: [
      'Confirmar con EMG en FDI o tenar',
      'Estudio genético (DMPK, CNBP)',
    ],
  },
  orientationHints: {
    temporalFit: ['chronic'],
    whenToSuspect: 'Debilidad distal, cataratas, calvicie frontal, miotonía al apretón de manos',
  },
};
